import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["idVerifiedSelect", "customOptionField", "customOptionWrapper", "recipientNameField", "verificationNotesWrapper", "verificationNotesField", "submitButton", "keyCheckbox"]

  connect() {
    this.toggleCustomOption()
    this.toggleVerificationNotes()
    this.validateForm()
  }

  toggleCustomOption() {
    const selectedValue = this.idVerifiedSelectTarget.value

    if (selectedValue === "other") {
      this.customOptionWrapperTarget.classList.remove("hidden")
      this.customOptionFieldTarget.setAttribute("required", "required")
    } else {
      this.customOptionWrapperTarget.classList.add("hidden")
      this.customOptionFieldTarget.removeAttribute("required")
      this.customOptionFieldTarget.value = ""
    }
    this.validateForm()
  }

  toggleVerificationNotes() {
    const recipientName = this.recipientNameFieldTarget.value.trim()

    if (recipientName.length > 0) {
      this.verificationNotesWrapperTarget.classList.remove("hidden")
    } else {
      this.verificationNotesWrapperTarget.classList.add("hidden")
    }
    this.validateForm()
  }

  validateForm() {
    const isValid = this.isFormValid()
    this.submitButtonTarget.disabled = !isValid
  }

  isFormValid() {
    // 1) Check if at least one key is selected
    const selectedKeys = this.keyCheckboxTargets.filter(checkbox => checkbox.checked)
    if (selectedKeys.length === 0) return false

    // 2) Check if id_verified is selected
    const idVerified = this.idVerifiedSelectTarget.value
    if (!idVerified) return false

    // 3) Check if id_verified is "other" but custom option is empty
    if (idVerified === "other") {
      const customOption = this.customOptionFieldTarget.value.trim()
      if (!customOption) return false
    }

    // 4) Check if recipient_name has content but verification_notes is empty
    const recipientName = this.recipientNameFieldTarget.value.trim()
    if (recipientName.length > 0) {
      const verificationNotes = this.verificationNotesFieldTarget.value.trim()
      if (!verificationNotes) return false
    }

    return true
  }
}
